import {isPlatformBrowser} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {DcpEntryGroup, LocalStorageService} from '@dcp/configurator';
import {OrderEntry} from '@spartacus/cart/base/root';
import {Observable, ReplaySubject} from 'rxjs';
import {DcpOrder} from '../../model/order/dcp-order.model';

@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationPageService {
  readonly ORDER_CONFIRMATION_PREFIX = 'orderReview_';
  readonly ORDER_ENTRIES_KEY = this.ORDER_CONFIRMATION_PREFIX + 'orderEntries';
  readonly CART_ENTRY_GROUPS_KEY = this.ORDER_CONFIRMATION_PREFIX + 'cartEntryGroups';
  readonly ORDER_KEY = this.ORDER_CONFIRMATION_PREFIX + 'order';

  private orderDetails$ = new ReplaySubject<DcpOrder>(1);

  constructor(@Inject(PLATFORM_ID) public platformId: object, private localStorageService: LocalStorageService) {
    const savedOrder = this.getOrderDetails();
    if (savedOrder) {
      this.orderDetails$.next(savedOrder);
    }
  }

  getOrderEntries(): OrderEntry[] | undefined {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(this.localStorageService.getItem(this.ORDER_ENTRIES_KEY));
    }
  }

  getCartEntryGroups(): DcpEntryGroup[] | undefined {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(this.localStorageService.getItem(this.CART_ENTRY_GROUPS_KEY));
    }
  }

  getOrderDetails(): DcpOrder | undefined {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(this.localStorageService.getItem(this.ORDER_KEY));
    }
  }

  getOrderDetails$(): Observable<DcpOrder> {
    return this.orderDetails$.asObservable();
  }

  saveOrderDetails(orderDetails: DcpOrder): void {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorageService.setItem(this.ORDER_ENTRIES_KEY, JSON.stringify(orderDetails?.entries));
      this.localStorageService.setItem(this.ORDER_KEY, JSON.stringify(orderDetails));
      this.orderDetails$.next(orderDetails);
    }
  }

  saveCartEntryGroups(cartEntryGroups: DcpEntryGroup[]): void {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorageService.setItem(this.CART_ENTRY_GROUPS_KEY, JSON.stringify(cartEntryGroups));
    }
  }

  clear() {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorageService.removeLocalStorageItemsByPrefix(this.ORDER_CONFIRMATION_PREFIX);
    }
  }
}
